// extracted by mini-css-extract-plugin
module.exports = {"monsterCardFooter":"Footer_monsterCardFooter__2UcLp"};